module.exports = __webpack_public_path__ + "img/baoxiaomi-opk-guide.91dd13c5.png";